import { render, staticRenderFns } from "./popoverText.vue?vue&type=template&id=60c5981d&scoped=true"
import script from "./popoverText.vue?vue&type=script&lang=js"
export * from "./popoverText.vue?vue&type=script&lang=js"
import style0 from "./popoverText.vue?vue&type=style&index=0&id=60c5981d&prod&lang=scss&scoped=true"
import style1 from "./popoverText.vue?vue&type=style&index=1&id=60c5981d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c5981d",
  null
  
)

export default component.exports